.source-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: var(--skeleton-grey);
    border-radius: 2px;
    padding: 2px 4px 2px 8px;

    margin: 0 12px;
}

.source-row--no-horizontal-margin {
    margin: 0;
}
